/* Commons */
export { default as PageHeader } from './lib/commons/PageHeader';
export { default as PageMain } from './lib/commons/PageMain';
export { MenuCard } from './lib/commons/MenuCard';
export { default as Sidemenu } from './lib/commons/Sidemenu';
export { LanguageSwitcher } from './lib/commons/LanguageSwitcher';
export { default as SideLogin } from './lib/commons/SideLogin';
export { default as SideEmpty } from './lib/commons/SideEmpty';
export { default as DialogConfirm } from './lib/commons/DialogConfirm';
export { default as DialogModal } from './lib/commons/DialogModal';
export { PanelTitle } from './lib/commons/PanelTitle';
export { default as ExpandablePanel } from './lib/commons/ExpandablePanel';
export { FilesDisplay } from './lib/commons/FilesDisplay';
export type { FileItem, FilesDisplayProps } from './lib/commons/FilesDisplay';
export { FilesDisplayEditable } from './lib/commons/FilesDisplayEditable';
export type {
  FileItemEditable,
  FilesDisplayEditableProps,
} from './lib/commons/FilesDisplayEditable';
export { default as ErrorPage } from './lib/commons/ErrorPage';
export { default as NotFoundPage } from './lib/commons/NotFoundPage';
export { default as GenericErrorPage } from './lib/commons/GenericErrorPage';
export { default as LoadingOverlay } from './lib/commons/LoadingOverlay';
export { default as SimpleAppRouterProgressProvider } from './lib/commons/SimpleAppRouterProgressProvider';
export { default as ToastProvider } from './lib/commons/ToastProvider';
export { useToast } from './lib/commons/useToast';

/* Icons */
export {
  TrashIcon,
  PencilIcon,
  DuplicateIcon,
  EyeIcon,
  ArrowLeftIcon,
  SearchIcon,
  MessagerieIcon,
  ProfileIcon,
  AnimauxIcon,
  ExamensIcon,
  Examens,
  BriefCaseIcon,
  UserIcon,
  NoDataIcon,
  LoadingSpinner,
  ExclamationCircleIcon,
  ExpandableMarkerIcon,
  RepeatIcon,
} from './lib/icons';

/* Forms */
export { default as Button } from './lib/forms/Button';
export { default as Input } from './lib/forms/Input';
export { default as Textarea } from './lib/forms/Textarea';
export { TextEditor } from './lib/forms/TextEditor';
export { default as Select } from './lib/forms/Select';
export { FormPanel } from './lib/forms/FormPanel';
export { FormField } from './lib/forms/FormField';
export { DisplayField } from './lib/forms/DisplayField';
export { FormSeparator } from './lib/forms/FormSeparator';
export { Form } from './lib/forms/Form';
export { ZodForm } from './lib/forms/ZodForm';
export { z, zodResolver } from './lib/forms/ZodForm';
export { default as SelectMultiButtons } from './lib/forms/SelectMultiButtons';
export { default as SelectButton } from './lib/forms/SelectButton';
export { default as Toggle } from './lib/forms/Toggle';
export { default as SelectEntity } from './lib/forms/SelectEntity';
export { default as SelectMultiTreeOptions } from './lib/forms/SelectMultiTreeOptions';
export { default as ReadOnlySelectMultiTreeOptions } from './lib/forms/ReadOnlySelectMultiTreeOptions';
export { default as SelectTreeOptions } from './lib/forms/SelectTreeOptions';
export { default as ReadOnlySelectTreeOptions } from './lib/forms/ReadOnlySelectTreeOptions';

export { FileUploadField } from './lib/forms/FileUploadField';

/* Form Hooks */
export * from './lib/forms/hooks';

/* Form Schemas */
export * from './lib/forms/schemas';

/* List */
export { ListFilter } from './lib/list/ListFilter';
export { DataGrid } from './lib/list/DataGrid';
export type { DataGridColumn } from './lib/list/DataGrid';
export { DataGridTable } from './lib/list/DataGridTable';
export { DataGridCard } from './lib/list/DataGridCard';
export { DataGridNoData } from './lib/list/DataGridNoData';
export { SkeletonRow, MobileSkeletonCard } from './lib/list/DataGridSkeletons';
export { Pagination } from './lib/list/Pagination';
export type { BaseFilter } from './lib/types/Base';

/* Types */
export type { ExamenFilter, ExamenStatus } from './lib/types/Examens';
export type { Option } from './lib/types/Base';
export type {
  TreeSelectionOption as TreeSelectionSelection,
  TreeSelectionValue as TreeSelectionSelectionValue,
  TreeSelectionValue,
} from './lib/types/TreeOptionType';

// /* Messages */
export { default as enMessages } from './messages/en.json';
export { default as frMessages } from './messages/fr.json';

/* Data */
export { examenClassName } from './lib/data/examen';
/* Utils */
export { cn } from './lib/utils/cn';

/* PDF */
export {
  InterpretationPDF,
  registerInterpretationPDFFonts,
} from './lib/pdf/InterpretationPDF';
export type {
  InterpretationPDFProps,
  InterpretationPDFTranslations,
  InterpretationPDFFonts,
  InterpretationPDFWrapperProps,
  AnimalInfo,
} from './lib/pdf/InterpretationPDF';
export * from './lib/legal/terms';
export * from './lib/legal/TermsAcceptanceScreen';
